import { useSelector } from 'react-redux'

import { ListContactsApiArg } from '@/__generated/es-api'
import { SubscriptionQuery } from '@/app/module/campaigns/types/subscriptions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'

export const useGetContactsWithSubscriptions = (campaignId: number, query: SubscriptionQuery) => {
  const orgId = useSelector(selectOrgId)

  const params: ListContactsApiArg = {
    orgId: orgId.toString(),
    page: query.page,
    size: query.size,
    search: query.searchTerm || undefined,
    subscriptionstatus: campaignId,
    subscriptionfilter: query.subscriptionFilter || undefined,
  }

  return esApi.endpoints.listContacts.useQuery(params, {
    skip: !orgId || !campaignId,
  })
}
